import { v4 as uuidv4 } from 'uuid';

export function getSessionId() {
    const savedId = localStorage.getItem('session_id')
    if (savedId) {
        return savedId
    }
    const newId = uuidv4()
    localStorage.setItem('session_id', newId)
}